module.exports = __webpack_public_path__ + "static/media/query_top_alpha_bg.2e18b190.png";